import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	return (
		<a href={post.permalink} className="pfa-doctor-card">
			{!!post.featured_image && (
				<figure
					className="pfa-doctor-card__figure"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-doctor-card__content">
				<h3
					className="pfa-doctor-card__title t4"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
				/>
			</div>
			<span className="pfa-doctor-card__link btn btn-tertiary">Read Bio</span>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
